import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const programsScreenModule = defineScreen({
  app: "coaching",
  screen_id: "programs",
  path: "/programs",
  heading: { text: "Programs", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "allow",
    "company_admin": "allow",
    "participant": "deny",
    "cohort_lead": "deny"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "page.load" }
  ],
  recipe: "Page-1",
  data: { seedNeeds: ["readonly-walk-session"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/programs.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default programsScreenModule;
